import { RouteObject } from 'react-router-dom';
import ABNLookupAndCountryPage from '@/modules/entity/pages/ABNLookupAndCountryPage.tsx';
import CreateEntityPage from '@/modules/entity/pages/CreateEntityPage.tsx';
import FollowUpDetails from '@/modules/entity/pages/FollowUpDetails.tsx';
import SelectEntityPageNew from '@/modules/entity/pages/SelectEntityPageNew.tsx';
import SelectRegisterPage from '@/modules/entity/pages/SelectRegisterPage.tsx';
import SignupEntityPage from '@/modules/entity/pages/SignUpEntityPage.tsx';
import SubscribePage from '@/modules/entity/pages/SubscribePage.tsx';
import VerificationPage from '@/modules/entity/pages/VerificationPage.tsx';

export const entityPaths = {
  static: {
    abnLookupEntity: '/create-entity/abn-lookup',
    createEntity: '/create-entity/select-type',
    updateEntity: '/update-entity',
    entityList: '/select-entity',
    subscribe: '/subscribe',
    verification: '/verification',
    selectRegister: '/select-register',
    followUp: '/follow-up',
  },
  dynamic: {
    updateEntity: (entityId = ':id') => entityPaths.static.updateEntity + '/' + entityId,
    subscribe: (entityId = ':id') => entityPaths.static.subscribe + '/' + entityId,
    followUp: (entityId = ':id') => entityPaths.static.followUp + '/' + entityId,
  },
};

export const getEntityRoutes = () => {
  const router: RouteObject[] = [
    {
      path: entityPaths.dynamic.updateEntity(),
      element: <SignupEntityPage />,
    },
    {
      path: entityPaths.static.createEntity,
      element: <CreateEntityPage />,
    },
    {
      path: entityPaths.static.abnLookupEntity,
      element: <ABNLookupAndCountryPage />,
    },
    {
      path: entityPaths.static.entityList,
      element: <SelectEntityPageNew />,
    },
    {
      path: entityPaths.dynamic.subscribe(),
      element: <SubscribePage />,
    },
    {
      path: entityPaths.static.verification,
      element: <VerificationPage />,
    },
    {
      path: entityPaths.static.selectRegister,
      element: <SelectRegisterPage />,
    },
    {
      path: entityPaths.dynamic.followUp(),
      element: <FollowUpDetails />,
    },
  ];

  return router;
};
